// eslint-disable-next-line import/no-anonymous-default-export
const configUrl = {
    ImgBaseUrl:`${process.env.PUBLIC_URL}`,
    APIImagesdURL:'https://www.7nsoft.com/api/'
    }
    
export default configUrl;


